import { createTheme } from '@mui/material/styles';
import Palette from './palette';
import useConfig from 'hooks/useConfig';

// const { navType } = useConfig();
const navType = 'light';

// Create the theme using navType and presetColor
const themeOptions = {
  palette: Palette(navType)
};

// const themes = createTheme(themeOptions);
//fixed, was doing createTheme inside the palette as well
const themes = themeOptions.palette;
// console.log(themes.palette.primary.main);
// console.log(themeOptions.palette);
export default themes;
